﻿<div class="rdo-inline rdo-expander" [ngClass]="{'rdo-expander-gray' : true || !expanded}" id="book-col-expander">
  <table class="table table-nowrap">
    <colgroup>
    <col [ngStyle]="{'width': (masterColumn.width ? masterColumn.width : 110) + 'px'}">
  </colgroup>
  <thead>
    <tr>
      <th (click)="expanded=!expanded">
        <div class="text-left">{{tableTitle}}
          @if (!group.locked) {
            <a (click)="toggleColumnVisibility(group)" title="{{'main.core.tables.common.hide_column_group' | translate}}">
              <img class="close" src="/assets/images/close.png">
            </a>
          }
        </div>
        <div class="text-right text-muted">
          <i class="fa"
          [class.fa-angle-right]="!expanded"></i>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr [ngStyle]="headerStyle">
      <th [ngStyle]="masterColumn.headerStyle">
        <rdo-sort-header [column]="masterColumn"
          [currentSortColumn]="sortOn"
          [desc]="desc"
          (descChange)="setSortDirection(!desc)"
          (columnClick)="setSortColumn(masterColumn)"
          [sortInProgress]="sortInProgress"
          >
        </rdo-sort-header>
      </th>
    </tr>
    @for (row of gridData; track row; let rowIndex = $index) {
      <tr [ngClass]="{'clickable-row' : isExpandable(), 'table-expanded-row-first': row.data.expanded}" (click)="toggleChildren(row, rowIndex)">
        <td [ngClass]="row.cells[0].class"
          [ngStyle]="row.cells[0].style">
          @if (row.cells[0].href) {
            <a
              (click)="clickCellLink(row.cells[0].config, row.data.raw)"
            href="{{row.cells[0].href}}">{{ row.cells[0].value }}</a>
          }
          @if (!row.cells[0].href && isBool(row.cells[0].value) && row.cells[0].value) {
            <i class="fa fa-check"></i>
          }
          @if (!row.cells[0].href && !isBool(row.cells[0].value)) {
            <span>{{ row.cells[0].value }}</span>
          }
          &nbsp;
        </td>
      </tr>
      @if (isExpandable()) {
        <tr>
          <td [attr.colspan]="columnList.length" style="border: none; padding: 0;">
            <div class="rdo-expander-row" [style.height]="childrenHeightStyle(row)" >
              <table class="table table-nowrap rdo-table-pretty" style="margin-bottom: 0;">
                <colgroup>
                <col [ngStyle]="{'width': (masterColumn.width ? masterColumn.width : 110) + 'px'}">
              </colgroup>
              <tbody>
                @for (child of row.childRows; track child) {
                  <tr class="table-expanded-row">
                    <td [ngStyle]="child.cells[0].style" [ngClass]="child.cells[0].class">
                      @if (child.cells[0].href) {
                        <a (click)="clickCellLink(child.cells[0].config, child.data.raw, row.data.raw)" href="{{child.cells[0].href}}"> {{ child.cells[0].value }}</a>
                      }
                      @if (!child.cells[0].href && isBool(child.cells[0].value) && child.cells[0].value) {
                        <i class="fa fa-check"></i>
                      }
                      @if (!child.cells[0].href && !isBool(child.cells[0].value)) {
                        <span>{{ child.cells[0].value }}</span>
                      }
                      &nbsp;
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    }
  }
</tbody>
</table>
</div>
<div class="rdo-inline rdo-expand" [style.width]="tableWidthStyle()">
  <table class="table table-nowrap" [ngStyle]="{'width':  collapsedTableWidth  + 'px'}">
    <colgroup>
    @for (c of collapsedColumns; track c) {
      <col [ngStyle]="{'width': (c.width ? c.width : defaultWidth) + 'px'}">
    }
  </colgroup>
  <thead>
    <tr>
      <th [attr.colspan]="collapsedColumns.length" (click)="expanded=!expanded">
        <br>
          <div class="text-right">
            <i class="fa fa-angle-left text-muted" style="margin-right: 2px" title="Collapse Column Group"></i>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr [ngStyle]="headerStyle">
        @for ( c of collapsedColumns; track  c) {
          <th [ngStyle]="c.headerStyle">
            <rdo-sort-header  [column]="c"
              [currentSortColumn]="sortOn"
              [desc]="desc"
              (descChange)="setSortDirection(!desc)"
              (columnClick)="setSortColumn(c)"
              [sortInProgress]="sortInProgress"
              >
            </rdo-sort-header>
          </th>
        }
      </tr>
      @for (row of gridData; track row; let rowIndex = $index) {
        <tr [ngClass]="{'clickable-row' : isExpandable(), 'table-expanded-row-first': row.data.expanded}" (click)="toggleChildren(row, rowIndex)">
          @for (i of collapsedIndices; track i) {
            <td
              [ngClass]="row.cells[i].class"
              [ngStyle]="row.cells[i].style">
              @if (row.cells[i].href) {
                <a
                  (click)="clickCellLink(row.cells[i].config, row.data.raw)"
                href="{{row.cells[i].href}}">{{ row.cells[i].value }}</a>
              }
              @if (!row.cells[i].href && isBool(row.cells[i].value) && row.cells[i].value) {
                <i class="fa fa-check"></i>
              }
              @if (!row.cells[i].href && !isBool(row.cells[i].value)) {
                <span>
                {{ row.cells[i].value }}</span>
              }
              &nbsp;
            </td>
          }
        </tr>
        @if (isExpandable()) {
          <tr>
            <td [attr.colspan]="collapsedIndices.length" style="border: none; padding: 0;">
              <div class="rdo-expander-row" [style.height]="childrenHeightStyle(row)">
                <table class="table table-nowrap rdo-table-pretty" style="margin-bottom: 0;">
                  <colgroup>
                  @for (c of collapsedColumns; track c) {
                    <col [ngStyle]="{'width': (c.width ? c.width : defaultWidth) + 'px'}">
                  }
                </colgroup>
                <tbody>
                  @for (child of row.childRows; track child) {
                    <tr class="table-expanded-row">
                      @for (i of collapsedIndices; track i) {
                        <td [ngStyle]="child.cells[i].style" [ngClass]="child.cells[i].class">
                          @if (child.cells[i].href) {
                            <a (click)="clickCellLink(child.cells[i].config, child.data.raw, row.data.raw)" href="{{child.cells[i].href}}"> {{ child.cells[i].value }}</a>
                          }
                          @if (!child.cells[i].href) {
                            <span>{{ child.cells[i].value }}</span>
                          }
                          &nbsp;
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
</div>
